<script setup lang="ts">
    import type { RouteLocationRaw } from 'vue-router';

    const props = defineProps<{
        contactId: string;
        firstName?: string;
        lastName?: string;
        email?: string;
        isActive?: boolean;
        hasBounced?: boolean;
        smsNumber?: string;
        isSmsActive?: boolean;
        hasSmsBounced?: boolean;
        to?: RouteLocationRaw;
    }>();

    const emit = defineEmits<{
        navigate: [];
    }>();

    const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';

    const contactName = () => [props.firstName, props.lastName].filter(Boolean).join(' ') || $Resources.NoContactNamePlaceholder;
</script>

<template>
    <h2 class="h4 item-heading">
        <template v-if="contactId !== GUID_EMPTY">
            <router-link v-if="to" :to="to">{{ contactName() }}</router-link>
            <a v-else href="javascript:void(0)" role="button" @click.prevent="emit('navigate')">{{ contactName() }}</a>
        </template>
        <span v-else>{{ contactName() }}</span>
    </h2>

    <p v-if="contactId !== GUID_EMPTY && (email || smsNumber)" class="d-flex col-gap-lg flex-wrap">
        <span v-if="email">
            {{ email }}
            <span v-if="isActive === false" class="unsubscribed-status">
                <span class="glyphicon glyphicon-ban-circle m-xs-r"></span>
                <small>{{ $Resources.UnsubscribedStatus }}</small>
            </span>
            <span v-if="hasBounced" class="bounced-status m-xs-r">
                <span class="glyphicon glyphicon-circle-arrow-left m-xs-r"></span>
                <small>{{ $Resources.BouncedStatus }}</small>
            </span>
        </span>

        <span v-if="smsNumber">
            {{ smsNumber }}
            <span v-if="isSmsActive === false" class="unsubscribed-status">
                <span class="glyphicon glyphicon-ban-circle m-xs-r"></span>
                <small>{{ $Resources.UnsubscribedStatus }}</small>
            </span>
            <span v-if="hasSmsBounced" class="bounced-status m-xs-r">
                <span class="glyphicon glyphicon-circle-arrow-left"></span>
                <small>{{ $Resources.BouncedStatus }}</small>
            </span>
        </span>
    </p>
</template>
